export default "__VITE_ASSET__Dk7i9gv6__"